
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire222e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire222e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dxJ7M", function(module, exports) {

$parcel$export(module.exports, "update_content", () => $3b316fa479f6054d$export$ede93e15d3f67f79);

var $rMwjd = parcelRequire("rMwjd");

var $gPnRu = parcelRequire("gPnRu");
const $3b316fa479f6054d$var$backButton = document.getElementById("back-button");
function $3b316fa479f6054d$export$ede93e15d3f67f79(folderId) {
    fetch(`/drive/folder?folder_id=${folderId}`).then((response)=>response.json()).then((data)=>{
        (0, $rMwjd.folders).setContent(data.filter((res)=>res.mimeType == (0, $rMwjd.FOLDERMIME)));
        (0, $gPnRu.files).setContent(data.filter((res)=>res.mimeType != (0, $rMwjd.FOLDERMIME)));
        // Include a special link to go back to the previous folder
        $3b316fa479f6054d$var$backButton.onFolderChange(folderId);
    });
}

});
parcelRegister("rMwjd", function(module, exports) {

$parcel$export(module.exports, "FOLDERMIME", () => $67e1111ffb3be5ce$export$491399fbe0bdc60e);
$parcel$export(module.exports, "Folder", () => $67e1111ffb3be5ce$export$80729fed35a16515);
$parcel$export(module.exports, "folders", () => $67e1111ffb3be5ce$export$9b9ee9fa673496c9);

var $jX8fY = parcelRequire("jX8fY");

var $dxJ7M = parcelRequire("dxJ7M");
const $67e1111ffb3be5ce$export$491399fbe0bdc60e = "application/vnd.google-apps.folder";
class $67e1111ffb3be5ce$export$80729fed35a16515 extends HTMLElement {
    constructor(parent, i){
        super();
        const icon = document.createElement("i");
        icon.classList.add("gg-folder");
        this.label = document.createElement("folder-name");
        this.append(icon, this.label);
        this.addEventListener("click", this.onClick.bind(this));
        this.classList.add("drive-folder");
    }
    onClick() {
        // this.classList.add('fadeout');
        (0, $dxJ7M.update_content)(this.data.id);
    }
    update(data) {
        this.data = data;
        this.label.textContent = this.data.title;
    }
    show() {
        this.classList.remove("hidden");
    }
    hide() {
        this.classList.add("hidden");
    }
}
const $67e1111ffb3be5ce$var$foldersList = document.getElementById("folders-list");
const $67e1111ffb3be5ce$export$9b9ee9fa673496c9 = new (0, $jX8fY.Container)($67e1111ffb3be5ce$var$foldersList, $67e1111ffb3be5ce$export$80729fed35a16515);
window.customElements.define("drive-folder", $67e1111ffb3be5ce$export$80729fed35a16515);

});
parcelRegister("jX8fY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $96dc079d0b781051$export$42a852a2b6b56249);
class $96dc079d0b781051$export$d514e8710c3bc90a extends HTMLElement {
}
class $96dc079d0b781051$export$42a852a2b6b56249 {
    constructor(parent, elementType){
        // Makes it easier to add elements or
        // update already existing ones.
        this.content = new Array();
        this.parent = parent;
        this.elementType = elementType;
    }
    setContent(content) {
        // Displays the given list of objects
        for(var i = 0; i < content.length; i++)this.addOrUpdate(content[i], i);
        this.hideFrom(i);
    }
    addOrUpdate(data, i = 0) {
        if (this.content[i]) {
            // If an object has been created already,
            // update its content and show it
            this.content[i].update(data);
            this.content[i].show();
        } else {
            // Otherwise, create a new one
            const e = new this.elementType(this.parent, i);
            e.update(data);
            e.show();
            this.content.push(e);
            this.parent.append(e);
        }
    }
    hideFrom(i = 0) {
        // Start hiding elements from i till the end
        for(; i < this.content.length; i++)this.content[i].hide();
    }
}

});


parcelRegister("gPnRu", function(module, exports) {

$parcel$export(module.exports, "files", () => $5e65222fef0ae394$export$3a444357c5f65f65);

var $jX8fY = parcelRequire("jX8fY");

var $hpZjJ = parcelRequire("hpZjJ");
class $5e65222fef0ae394$var$File extends HTMLElement {
    constructor(parent, i){
        super();
        this.clicked = false;
        this.image = document.createElement("img");
        this.label = document.createElement("file-name");
        this.link = document.createElement("a");
        this.link.style.display = "none";
        this.append(this.image, this.label, this.link);
        this.addEventListener("click", this.onClick.bind(this));
        this.classList.add("drive-file");
    }
    onClick() {
        if (!this.clicked) {
            this.clicked = true;
            this.classList.add("clicked");
            this.link.href = `/drive/file?file_id=${this.data.id}`;
            this.link.download = this.data.title;
            this.link.click();
            setTimeout(()=>{
                this.classList.remove("clicked");
                this.clicked = false;
            }, 5000);
        }
    }
    update(data) {
        this.data = data;
        this.label.textContent = this.data.title;
        this.image.src = (0, $hpZjJ.match)(data.mimeType);
    }
    show() {
        this.classList.remove("hidden");
    }
    hide() {
        this.classList.add("hidden");
    }
}
const $5e65222fef0ae394$var$filesList = document.getElementById("files-list");
const $5e65222fef0ae394$export$3a444357c5f65f65 = new (0, $jX8fY.Container)($5e65222fef0ae394$var$filesList, $5e65222fef0ae394$var$File);
window.customElements.define("drive-file", $5e65222fef0ae394$var$File);

});
parcelRegister("hpZjJ", function(module, exports) {

$parcel$export(module.exports, "match", () => $4c84189bf054b5d0$export$4659b591c19bdf3d);
const $4c84189bf054b5d0$var$images = {
    audio: "https://telegra.ph/file/83285485816f7cf0fcf67.png",
    image: "https://telegra.ph/file/a1f5285c74ce80d8fa554.png",
    pdf: "https://telegra.ph/file/cc429f1e5d235f54a4500.png",
    document: "https://telegra.ph/file/a12324faf7e9385ed23e8.png",
    file: "https://telegra.ph/file/6995dd010a84417175963.png"
};
function $4c84189bf054b5d0$export$4659b591c19bdf3d(mime) {
    const entries = Object.entries($4c84189bf054b5d0$var$images);
    for(let i = 0; i < entries.length; i++){
        if (mime.includes(entries[i][0])) return entries[i][1];
    }
    return $4c84189bf054b5d0$var$images.file;
}

});




var $dxJ7M = parcelRequire("dxJ7M");
(0, $dxJ7M.update_content)("");


//# sourceMappingURL=index.6eab88fa.js.map
